import React, { useState, useEffect } from "react";
import { iconDemo } from "utils/constants";
import { connect } from "react-redux";
import { compose } from "redux";
import { useNavigate } from "react-router-dom";
import AuthActions from "store/auth/actions";
import enhancer from "./enhancer/LoginFormEnhancer";
import api from "api";
// import loginBackVideo from "assets/images/VídeoBackGround.mp4";
import styles from "./auth.module.css";
import AppModal from "components/ui/AppModal/AppModal";

const { login } = AuthActions;

const Login = props => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [modal, setModal] = useState({ open: false, variant: "error", title: "", message: "", onConfirm: null });
  const closeModal = () => setModal(m => ({ ...m, open: false }));
  const showModal = (variant, title, message, onConfirm = null) =>
    setModal({ open: true, variant, title, message, onConfirm: onConfirm ?? closeModal });

  const handleLogin = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post("/users/login", {
        email: values.email,
        password: values.password
      });
      if (response.status === 200) {
        const data = { token: response.data.access_token, email: values.email };
        props.login(data);
        navigate("/dashboard");
      } else {
        console.error("Erro durante o login:", response.data);
      }
    } catch (error) {
      if (error.response) {
        handleErrorResponse(error.response);
      } else if (error.request) {
        handleNetworkError();
      } else {
        handleGenericError();
      }
    } finally {
      setLoading(false);
    }
  };

  const handleErrorResponse = response => {
    const { status, data } = response;
    const detail = (data && data.detail ? String(data.detail) : "").toLowerCase();
    const isBlocked = status === 429 || detail.includes("bloque") || detail.includes("muitas tentativas");
    const needsVerification = status === 403 && (detail.includes("verifi") || detail.includes("email"));

    if (isBlocked) {
      showModal("error", "Muitas tentativas", "Muitas tentativas de login. Aguarde alguns minutos e tente novamente.");
    } else if (status === 401) {
      showModal("error", "Erro!", "Senha incorreta. Por favor, tente novamente.");
    } else if (status === 404) {
      showModal("error", "Erro!", "Usuário inexistente. Verifique o email fornecido.");
    } else if (needsVerification) {
      showModal("warning", "Verificação necessária!", "Por favor, verifique seu email antes de fazer login.", () => {
        closeModal();
        navigate("/verify-otp");
      });
    } else {
      showModal("error", "Erro!", "Ocorreu um erro durante o login. Tente novamente mais tarde.");
    }
  };

  const handleNetworkError = () => {
    showModal("error", "Erro de Rede!", "Houve um problema de rede. Verifique sua conexão e tente novamente.");
  };

  const handleGenericError = () => {
    showModal("error", "Erro!", "Ocorreu um erro durante o login. Tente novamente mais tarde.");
  };

  const { values, handleChange, handleBlur, errors, touched, submitCount, setValues } = props;

  useEffect(() => {
    const isLocalhost =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";
    if (isLocalhost) {
      setValues({
        email: process.env.REACT_APP_DEV_LOGIN_EMAIL || "",
        password: process.env.REACT_APP_DEV_LOGIN_PASSWORD || ""
      });
    }
  }, [setValues]);

  const Error = ({ field, class: cls }) => {
    if ((errors[field] && touched[field]) || submitCount > 0) {
      return <span className={cls || styles.errorMsg}>{errors[field]}</span>;
    }
    return <span />;
  };

  return (
    <div className={styles.root}>
{/* <video autoPlay muted loop className={styles.videoBg}>
        <source src={loginBackVideo} type="video/mp4" />
      </video> */}
      <div className={styles.overlay} />

      <div className={styles.card}>
        <div className={styles.logoWrap}>
          <img src={iconDemo} alt="Vertex4D" className={styles.logo} />
        </div>
        <h1 className={styles.title}>Acessar sua conta</h1>
        <p className={styles.subtitle}>Bem-vindo de volta. Insira suas credenciais.</p>

        <form onSubmit={handleLogin} noValidate>
          <div className={styles.formGroup}>
            <label className={styles.label}>Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className={styles.input}
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="seu@email.com"
              required
            />
            <Error field="email" />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Senha</label>
            <div className={styles.inputGroup}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                className={styles.input}
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="••••••••"
                required
              />
              <div
                className={styles.inputGroupAppend}
                onClick={() => setShowPassword(!showPassword)}
              >
                <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
              </div>
            </div>
            <Error field="password" />
          </div>

          <button
            type="button"
            className={styles.forgotLink}
            onClick={() => navigate("/forgotPassword")}
          >
            Recuperar senha
          </button>

          <button
            type="submit"
            className={`${styles.btn} ${styles.btnPrimary}`}
            disabled={loading}
          >
            {loading ? <><div className={styles.spinner} /> Entrando...</> : "Acessar"}
          </button>
        </form>

        <p className={styles.linkRow}>
          Não tem uma conta?{" "}
          <button className={styles.link} onClick={() => navigate("/register")}>
            Registre-se
          </button>
        </p>
      </div>

      <AppModal
        isOpen={modal.open}
        onClose={closeModal}
        allowOutsideClick={true}
        variant={modal.variant}
        title={modal.title}
        message={modal.message}
        confirmText="OK"
        onConfirm={modal.onConfirm}
      />
    </div>
  );
};

export default compose(enhancer, connect(null, { login }))(Login);
